import { Skeleton } from '@/components/ui/skeleton'
import { Table, TableBody, TableRow, TableCell } from '@/components/ui/table'

export const EventDeliveryListFallback = () => {
  return (
    <div className="mt-6 space-y-7">
      <Table>
        <TableBody>
          {Array.from({ length: 20 }).map((_, index) => (
            <TableRow key={index}>
              <TableCell className="p-0">
                <div className="px-2 py-1 flex items-center gap-2">
                  <Skeleton className="h-5.5 w-14" />
                  <Skeleton className="h-5.5 w-21" />
                </div>
              </TableCell>
              <TableCell className="p-0">
                <div className="px-2 py-1 flex items-center justify-end">
                  <Skeleton className="h-5.5 w-38" />
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Skeleton className="h-4 w-20 rounded" />
          <Skeleton className="h-8 w-20 rounded-md" />
        </div>
        <div className="flex items-center justify-center">
          <Skeleton className="h-4 w-20 rounded" />
        </div>
        <div className="flex items-center gap-2">
          <Skeleton className="size-8 rounded-md" />
          <Skeleton className="size-8 rounded-md" />
          <Skeleton className="size-8 rounded-md" />
          <Skeleton className="size-8 rounded-md" />
        </div>
      </div>
    </div>
  )
}
